
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { Component, OnInit, Injector, Optional, Inject, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';

import { Store, select } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import * as fromBckpStore from '@apps/bckp/store';

import { InputComboboxComponent } from '../../input-combobox/input-combobox.component';

@Component({
    selector: 'aa-input-policies',
    templateUrl: '../../input-combobox/input-combobox.component.html',
    styleUrls: [
        '../../input.component.scss',
        '../../input-combobox/input-combobox.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputPoliciesComponent,
            multi: true,
        }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputPoliciesComponent extends InputComboboxComponent implements OnInit
{
    constructor (
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        private store: Store<IAuroraState>,
        injector: Injector,
        cdRef: ChangeDetectorRef
    )
    {
        super(injector, validators, asyncValidators, cdRef);

        this.items = this.store
            .pipe(
                select(fromBckpStore.getPoliciesOptions)
            );
    }

    ngOnInit ()
    {
        this.store.dispatch(fromBckpStore.BckpOptionsStoreActions.BckpLoadPoliciesRequested());
    }
}
